module.exports = __webpack_public_path__ + "img/useful_hero_xl.e4c376eb.png";